import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from '../auth/auth.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard  {
  constructor(public auth: AuthService, public router: Router) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

      if (!this.auth.authenticated) {
        // Guarda la URL a la que el usuario intentaba acceder (solo si no es la raíz)
        const attemptedUrl = state.url;
        if (attemptedUrl !== '/' && attemptedUrl !== '/login') {
          localStorage.setItem('redirectUrl', attemptedUrl);
        }
        this.router.navigate(['login']);
        return false;
    }
      return true;
  }

}
